<app-account-subform-shell
  titleId="account-two-factor-title"
  variant="centered"
  [crumb]="'Account settings / Security' | translate"
  [title]="'One-time password' | translate"
  (back)="cancelled.emit()"
>
  <div class="otp-icon" aria-hidden="true"><app-account-icon name="shield-check" [size]="28"></app-account-icon></div>
  <div>
    <h2>
      @if (disabling) {
        {{ 'Verify to turn off two-factor authentication' | translate }}
      } @else {
        {{ 'Verify to turn on two-factor authentication' | translate }}
      }
    </h2>
    <p>{{ 'Enter the one-time password (OTP) we sent you.' | translate }}</p>
  </div>
  <app-account-otp-input
    [length]="codeLength"
    [invalid]="invalid"
    [label]="'Enter OTP' | translate"
    (codeChange)="onCodeChange($event)"
    (submitted)="verify()"
  ></app-account-otp-input>
  @if (invalid) {
    <div class="otp-error" role="alert">
      <app-account-icon name="alert-circle" [size]="16"></app-account-icon>
      {{ 'That code is incorrect. Please try again.' | translate }}
    </div>
  }
  <div class="resend">
    {{ "Didn't get it?" | translate }}
    <button type="button" class="resend-btn" [disabled]="resendCooldown > 0 || sending" (click)="resend()">
      @if (resendCooldown > 0) {
        {{ 'Resend in {{seconds}}s' | translate: { seconds: resendCooldown } }}
      } @else {
        {{ 'Resend code' | translate }}
      }
    </button>
  </div>

  <div subformFooter class="footer-actions">
    <button type="button" class="as-btn-secondary" (click)="cancelled.emit()">
      {{ 'Cancel' | translate }}
    </button>
    <button type="button" class="as-btn-primary verify" [disabled]="!canVerify" (click)="verify()">
      @if (disabling) {
        {{ 'Verify & disable' | translate }}
      } @else {
        {{ 'Verify & enable' | translate }}
      }
    </button>
  </div>
</app-account-subform-shell>
